<template>
    <ion-page>
        <ion-content>
            <ion-grid>
                <ion-row class="content-row" align-items-center>
                    <ion-col size-xs="12" offset-xs="0" size-sm="8" offset-sm="2" size-md="6" offset-md="3" size-lg="4" offset-lg="4" text-center>
                        <ion-img class="logo" :src="require('@/assets/logo_full_small.png')"></ion-img>
                        <ion-card class="signup">
                            <ion-card-header>
                                <ion-card-title>{{ $t('screens.signup.sign-up') }}</ion-card-title>
                            </ion-card-header>
                            <ion-card-content>
                                <ion-label class="subheader" text-left>{{ $t('screens.signup.with-email') }}</ion-label>
                                <ion-item>
                                    <ion-icon name="mail" color="medium"></ion-icon>
                                    <ion-input :placeholder="$t('screens.signup.placeholder-email')" type="email" @input="email = $event.target.value" @keyup.enter="signUp"></ion-input>
                                </ion-item>
                                <ion-label color="danger" v-if="error">{{error}}</ion-label>
                                <ion-button size="default" expand="block" @click="signUp">{{ $t('screens.signup.sign-up') }}</ion-button>
                                <div class="divider">{{ $t('screens.splash.or') }}</div>
                                <ion-button size="default" expand="block" class="fb" @click="fbLogin"><ion-icon name="logo-facebook"></ion-icon>{{ $t('screens.signup.sign-up-using') }} Facebook</ion-button>
                            </ion-card-content>
                        </ion-card>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-content>
    </ion-page>
</template>

<script>
    import validate from '@/validate';
    //import awsconfig from '@/aws-exports';

    export default {
        name: 'SignUp',
        data() {
            return {
                email: '',
                error: false
            }
        },
        methods: {
            signUp: function() {
                if (!this.email) {
                    this.error = this.$t('screens.signup.email-not-blank');
                } else if (!validate.email(this.email)) {
                    this.error = this.$t('screens.signup.email-invalid');
                } else {
                    this.error = false;
                    this.$store.setSignUpEmail(this.email);
                    this.$router.push('/location');
                }
            },
            fbLogin: async function() {
                //TODO: A potential PR in the way for federatedSignIn to accept redirectSignIn as an option
                /*awsconfig.oauth.redirectSignIn = process.env.VUE_APP_OAUTH_REDIRECT_SIGNUP;
                this.$Amplify.Auth.configure(awsconfig);*/
                return this.$Amplify.Auth.federatedSignIn({provider: 'Facebook'});
            }
        }
    }
</script>

<style scoped>
ion-content {
    --background: url('~@/assets/bg/bg3.jpg') no-repeat center center / cover;
}

ion-grid {
    height: 100%;
    font-family: 'Nunito', sans-serif;
    padding: 1em;
}

ion-input {
    margin-left: .5em;
}

ion-item {
    --background: rgba(255,255,255,.6);
    width: 98%;
    margin-left: 1%;
    margin-bottom: .5em;
}

ion-button {
    margin-top: 1em;
}

ion-label {
    font-family: 'Nunito', sans-serif;
    color: #fff;
    padding: .25em 0;
    display: block;
}

ion-card-header {
    --background: none;
}

ion-card {
    --background: rgba(255,255,255,.8);
    font-family: 'Nunito', sans-serif;
}

ion-card-title {
    --color: #333;
    font-size: 2.5em;
}

ion-col {
    padding: 0;
}

.content-row ion-label.subheader {
    color: #333;
    font-size: 1.4em;
}

.fb {
    --background: #3b5998;
    --background-hover: #8b9dc3;
    margin-top: .5em;
}

.fb ion-icon {
    margin-right: .5em;
}
</style>